import React from "react";

export default function Header() {

  return (
    <header>
      <div className='header-inner'>
        <div className='logo'>SD</div>
        
      </div>
    </header>
  );
}